import { render, staticRenderFns } from "./popup-department-item-do.vue?vue&type=template&id=0d238ae8&scoped=true"
import script from "./popup-department-item-do.vue?vue&type=script&lang=js"
export * from "./popup-department-item-do.vue?vue&type=script&lang=js"
import style0 from "./popup-department-item-do.vue?vue&type=style&index=0&id=0d238ae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d238ae8",
  null
  
)

export default component.exports